export const MONTHS: Array<string> = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const GROUPS: Array<string> = [
  "Directors",
  "Director",
  "Faculty",
  "Members",
  "Research Staff",
  "Students",
  "Administrator",
  "Administrative Staff",
  "Web Site",
]

export const RESEARCH_AREA_PATH: string = "/research-areas"
export const FACULTY_PATH: string = `${RESEARCH_AREA_PATH}/faculty`
export const LABS_PATH: string = `${RESEARCH_AREA_PATH}/labs`
